import { render, staticRenderFns } from "./IconDeleteCol.vue?vue&type=template&id=4bc5a606"
import script from "./IconDeleteCol.vue?vue&type=script&lang=js"
export * from "./IconDeleteCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports